import {Component} from '@angular/core';
import {ScheduleService} from '../../services/ScheduleService';
import {FormsModule} from '@angular/forms';
import {Checkbox} from 'primeng/checkbox';
import {Button} from 'primeng/button';
import {DueTimeItem} from './due-time-item';

declare var Yii: any;

@Component({
  selector: 'ng-schedule-due-time',
  templateUrl: './due-time.html',
  imports: [
    FormsModule,
    Checkbox,
    Button,
    DueTimeItem
  ],
  styles:[`
    :host {
      display: block;
    }
  `]
})
export class AssignmentScheduleDueTimeComponent {
  public Yii = Yii;

  constructor(public ssvc: ScheduleService) {}
}
